<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container is-fluid">
        <h2 class="title is-2">{{title}}</h2>
        <p class="subtitle is-3" v-if="source">{{source}}</p>
        <div class="columns">
          <div class="column is-half">
            <figure class="image images viewer" v-viewer>
              <img :src="fullPath(page1)" :alt="title"/>
            </figure>
          </div>
          <div class="column is-half" v-if="transcript1">
            <h3 class="title is-3">Transcript</h3>
            <pre>{{transcript1}}</pre>
          </div>
        </div>
        <div class="columns" v-if="page2">
          <div class="column is-half">
            <figure class="image images viewer" v-viewer>
              <img :src="fullPath(page2)" :alt="`${title} - page 2`" />
            </figure>
          </div>
          <div class="column is-half" v-if="transcript2">
            <pre>{{transcript2}}</pre>
          </div>
        </div>
        <router-link class="button is-primary is-medium back-button" :to="{name:'documents'}" aria-label="Go back to the list of documents">
          <span class="icon is-small">
            <i class="fas fa-arrow-left"></i>
          </span>
          <span>Back</span>
        </router-link>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import { documents } from "./documents";

export default {
  name: "Document",
  data() {
    return {
      documents
    };
  },
  methods: {
    fullPath: function(image) {
      return `documents/${image}`;
    }
  },
  computed: {
    title: function() {
      return this.documents[this.$route.params.document_id - 1].title;
    },
    source: function() {
      return this.documents[this.$route.params.document_id - 1].source;
    },
    transcript1: function() {
      return this.documents[this.$route.params.document_id - 1].transcript1;
    },
    transcript2: function() {
      return this.documents[this.$route.params.document_id - 1].transcript2;
    },
    page1: function() {
      return this.documents[this.$route.params.document_id - 1].page1;
    },
    page2: function() {
      return this.documents[this.$route.params.document_id - 1].page2;
    }
  },
  components: {
    Nav,
    Footer
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Mono&display=swap");
#app {
}

.content p {
  margin: 0 2rem !important;
}

.subconcept {
  padding-left: 3rem;
  padding-right: 3rem;
  margin-top: 1rem;
  padding-top: 1rem;
}

.subconcept-title {
  font-weight: bold;
  font-size: 1.2rem;
}
</style>